import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import LineSelectForm from '../../../components/Forms/LineSelectForm'
import SimpleModal from '../../../components/Modals/SimpleModal'
import RoundedButton from '../../../components/Actions/RoundedButton'
import LineAutocompleteForm from '../../../components/Forms/LineAutocompleteForm'

const AddArtistModal = ({ open, form, onChange, onSubmit, onClose, content }) => {

    return (
        <SimpleModal maxWidth='sm' open={open} onClose={onClose}>
            <Grid container alignItems='center' spacing={4}>
                <Grid item xs={12}>
                    <Typography variant='h6'>{content.title_artist}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <LineAutocompleteForm data={form.artist_id} onChange={onChange} />
                </Grid>
                <Grid item xs></Grid>
                <Grid item>
                    <RoundedButton size='small' onClick={() => onSubmit('artist')}>
                        {content.add_button}
                    </RoundedButton>
                </Grid>
            </Grid>
        </SimpleModal>
    )
}

export default AddArtistModal